export default "__VITE_ASSET__D91HcYQ7__"